import axios from 'axios';
import { IProfileCollection } from 'entities/Permission/Permission.models';

const basePath = '/permissions';

export const permissionTransport = {
  getProfiles: (): Promise<IProfileCollection> => axios.get(`${basePath}/profiles`),
};
